<!--基本信息-->
<template>
	<div class="basicInformation">
		<div class="details">
			<span style="display: flex;align-items: center;"><img :src="imgName('/huapu/anq.png')" />运行服务天数:<span style="color:#e2c21b">{{servicedays}}</span></span>
			<span>安全运行天数:<span style="color:#e2c21b">{{servicedays}}</span></span>
		</div>
		<!--通讯状态-->
		<div class="communicationState">
			<img :src="imgName('/huapu/communicationState.png')" />
			<span>通讯状态：</span>
			<img :src="imgName('/huapu/SmileyFace.png')" />
		</div>
		<!--下拉框-->
		<div class="dropDownBox flexCenter" :style="backImg('/huapu/searchBar.png')">
			<input type="text" v-model="dropDownValue" />
			<img :src="imgName('/huapu/searchFor.png')" @click="searchFor()" />
		</div>
		<div v-if="dropDownBoxShow" class="dropDownList">
			<ul class="xaUl">
				<li v-for="item in filterList" @click="dropDownItem(item)">{{item.name}}</li>
			</ul>
		</div>
		<!--详细信息-->
		<div class="basicInforData flexBetween">
			<div class="baseicInforDatachild flexCenterColumn" :style="backImg('/huapu/powerRoom.png')">
				<span>水泵房数量</span>
				<span style="color: yellow;">{{filterList.length}}</span>
			</div>
			<div class="baseicInforDatachild flexCenterColumn" :style="backImg('/huapu/powerRoom.png')">
				<span>水泵数量</span>
				<span style="color: yellow;">{{transformerList.length}}</span>
			</div>
			<div class="baseicInforDatachild flexCenterColumn" :style="backImg('/huapu/powerRoom.png')">
				<span>运行水泵</span>
				<span style="color: yellow;">{{loadcapacity}}</span>
			</div>
		</div>
		<!--value-->
		<div class="basicInforValue flexBetween">
			<div class="basicInforValueChild flexCenterColumn">
				<div class="flexCenter">
					<img :src="imgName('/huapu/loadValue.png')">
					<span>{{realLoadRate}}%</span>
				</div>
				<span style="color: yellow;">{{realLoad}}</span>
				<span>实时水量(Mpa)</span>
			</div>
			<div class="basicInforValueChild flexCenterColumn">
				<div class="flexCenter">
					<img :src="imgName('/huapu/loadValue.png')">
					<span>{{dayMaxRate}}%</span>
				</div>
				<span style="color: yellow;">{{dayMaxLoad}}</span>
				<span>本日用水量(m³)</span>
			</div>
			<div class="basicInforValueChild flexCenterColumn">
				<div class="flexCenter">
					<img :src="imgName('/huapu/loadValue.png')">
					<span>{{monthMaxRate}}%</span>
				</div>
				<span style="color: yellow;">{{monthMaxLoad}}</span>
				<span>本月供水量(m³)</span>
			</div>
		</div>
	</div>
</template>
<script>
	import resourcesStore from '@/cache/resourcesStore.js'
	export default {
		components: {},
		props: {},
		data() {
			return {
				dropDownBoxShow: false,
				dropDownValue: '',
				filterList: [],
				transformerList: [],
				loadcapacity: 0,
				nowLoadDeviceFromname: "",
				dayMaxLoad: 0,
				monthMaxLoad: 0,
				dayMaxRate: 0,
				monthMaxRate: 0,
			}
		},
		created() {
			debugPage = this
		},
		mounted() {
			addNewTask("refreshUnitDayInfo", 0, 5 * 60 * 1000, -1, () => {
				this.getLoadValue(this.nowUnit.id)
			})
			this.filterList = copy(this.powerRoom)
			if (!isempty(this.transformerList)) {
				this.getArchivesInfo(this.transformerList)
				this.$store.cacheStore.commit("setTransformerList", this.transformerList)
			}
		},
		destroyed() {
			this.realTimeValueStore.commit("removeKeys", this.nowLoadDeviceFromname)
		},
		computed: {
			realTimeValueStore() {
				return this.$store.realTimeValueStore
			},
			imgName() {
				return resourcesStore.getters.getResourcesByName
			},
			backImg() {
				return this.$store.resourcesStore.getters.getBackgroudImageStyle
			},
			nowUnit() {
				return this.$store.unitStore.getters.getNowUnit
			},
			servicedays() {
				return Math.ceil((new Date().getTime() - this.nowUnit.joinTime) / 1000 / 60 / 60 / 24) + '天'
			},
			nowReadDeviceTree() {
				//当前单位可查看虚拟设备树
				return this.$store.deviceStore.getters.getReadDeviceTreeByUnitId(this.nowUnit.id)
			},
			nowArchivesTree() {
				//当前单位可查看台账设备树
				return this.$store.archivesStore.getters.getArchivesTreeByUnitId(this.nowUnit.id)
			},
			powerRoom() {
				//获取单位下所有配电房信息
				var list = treeToList(this.nowReadDeviceTree, 'next', item => {
					return item.hasOwnProperty("next")
				})
				return list.filter(item => {
					return item.devicetype == 2
				})
			},
			realLoad() {
				var list = this.nowLoadDeviceFromname
				var values = this.realTimeValueStore.getters.getValue(list)
				var count = 0
				for (var i = 0, len = values.length; i < len; i++) {
					count += parseInt(values[i])
				}

				//实时负荷
				return (Math.round(count * Math.pow(10, 2))) / Math.pow(10, 2)
			},
			realLoadRate() {
				if (this.loadcapacity != 0 && this.realLoad != 0) {
					return cutDigital(this.realLoad / this.loadcapacity * 100)
				}
				return 0
			},
		},
		watch: {
			powerRoom(nv, ov) {
				this.filterList = copy(this.powerRoom)
			},
			nowLoadDeviceFromname(nv, ov) {
				if (!isempty(ov)) {
					//移除旧变量
					this.realTimeValueStore.commit("removeKeys", ov)
				}
				if (!isempty(nv)) {
					this.realTimeValueStore.commit("addKeys", nv)
				}
			},
			dropDownValue(nv, ov) {
				this.filterList = []
				this.powerRoom.forEach(item => {
					if (item.name.indexOf(nv) > -1) {
						this.filterList.push(item)
					}
				})
			},
			powerRoom(nv, ov) {
				this.filterList = nv
			},
			filterList(nv, ov) {
				this.transformerList = []
				this.recursiveTfr(nv)
			},
			transformerList(nv, ov) {
				this.getArchivesInfo(nv)
				this.getLoadValue(this.nowUnit.id)
				this.$store.cacheStore.commit("setTransformerList", nv)
			},
		},
		methods: {
			//选中配电房
			dropDownItem(item) {
				this.dropDownBoxShow = false
				this.dropDownValue = item.name
			},
			//搜索配电房
			searchFor() {
				this.dropDownBoxShow = true
			},
			getLoadValue(unitId) {
				//获取单位相关的数据
				if (isempty(unitId)) {
					return
				}
				var deviceNos = ''
				this.transformerList.forEach((item, index) => {
					if (this.transformerList.length == index + 1) {
						deviceNos += item.no
					} else {
						deviceNos += item.no + ','
					}
				})
				//查询日最大负荷
				this.$api.powerApi.getDayMaxLoadDeviceNos('', new Date().getTime(), deviceNos, respon => {
					if (this.loadcapacity != 0 && respon != 0) {
						this.dayMaxRate = cutDigital(respon / this.loadcapacity * 100)
					} else {
						this.dayMaxRate = '0.00'
					}
					this.dayMaxLoad = respon
				})
				//查询月最大负荷
				this.$api.powerApi.getMonthMaxLoadDeviceNos('', new Date().getTime(), deviceNos, respon => {
					if (this.loadcapacity != 0 && respon != 0) {
						this.monthMaxRate = cutDigital(respon / this.loadcapacity * 100)
					} else {
						this.monthMaxRate = '0.00'
					}
					this.monthMaxLoad = respon
				})
				//获取实时负荷
				this.$api.powerApi.getLoadFromnameByUnitIdDeviceNos('', deviceNos, respon => {
					this.nowLoadDeviceFromname = respon
				})
			},
			getArchivesInfo(archivesTree) {
				this.loadcapacity = 0
				if (!isempty(archivesTree)) {
					var ids = ''
					archivesTree.forEach(e => {
						ids += e.archivesId + ','
					})
					if (isempty(ids)) {
						return
					}
					this.$api.archivesApi.getArchivesInfoByIds(ids, respon => {
						if (!isempty(respon)) {
							var temp1 = 0
							respon.forEach(e => {
								e.next.forEach(i => {
									if (i.propertyCode == 'Capacity') {
										if (!isempty(i.value)) {
											console.log(i.value)
											temp1 += parseFloat(i.value)
										}
									} else if (i.propertyCode == 'Power') {}
								})
							})
							this.loadcapacity = temp1 //额定容量
						}
					})
				}
			},
			recursiveTfr(item) {
				item.forEach(i => {
					if (!isempty(i.archivesTypeCode) || i.archivesTypeCode == 'Transformer') {
						this.transformerList.push(i)
					} else {
						if (!isempty(i.next)) {
							this.recursiveTfr(i.next)
						}
					}
				})
			}

		}
	}
</script>

<style scoped>
	.basicInformation {
		width: calc(30% - 20px);
		padding: 10px;
		height: calc(100% - 20px);
		position: relative;
	}

	.details {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.details img {
		width: .3rem;
	}

	.basicInformation span {
		color: white;
	}

	.details span {}

	.communicationState {
		display: flex;
		align-items: center;
		padding-top: .1rem;
	}

	.communicationState img {
		width: .3rem;
	}

	.communicationState span {
		padding-left: .1rem;
	}

	.dropDownBox {
		padding: 5px 0;
		margin: 5px 0;
		background-size: 100% 90%;
		background-repeat: no-repeat;
		display: -webkit-box;
		display: -ms-flexbox;
		display: flex;
		-webkit-box-align: center;
		-ms-flex-align: center;
		align-items: flex-start;
		-webkit-box-pack: center;
		-ms-flex-pack: center;
		justify-content: center;
	}

	.dropDownBox input {
		width: 50%;
		background-color: rgba(0, 0, 0, 0);
		color: white;
		outline: none;
		border: 0;
		border-bottom: .01rem solid yellow;
		border-radius: 0;
		line-height: 16px;
		font-size: 12px;
		margin-right: 5px;
	}

	.dropDownBox input:focus {
		border: 0;
		outline: none;
		background-color: #143a70;
		border-bottom: .01rem solid yellow;
		border-radius: 0;
		width: 50%;
	}

	.dropDownBox img {
		height: 22px;
	}

	.elAutoComplete {
		width: 100%;
	}

	.dropDownList {
		width: 40%;
		background-color: white;
		position: absolute;
		left: 28%;
		top: 30%;
		max-height: 25%;
		z-index: 999;
		overflow-y: overlay;
	}

	.dropDownList ul li {
		padding: 0 0 .1rem .1rem;
	}

	.dropDownList ul li:nth-child(1) {
		padding-top: .1rem;
	}

	.dropDownList ul li:hover {
		background-color: rgba(0, 0, 0, 0.1);
	}

	.basicInforData {
		height: calc((100% - 117px)*0.3);
	}

	.baseicInforDatachild {
		width: 30%;
		height: calc(100% - 8px);
		padding: 4px 0;
		background-repeat: no-repeat;
		background-size: 100%;
	}

	.baseicInforDatachild span {}

	.basicInforValue {
		height: calc((100% - 117px)*0.7);
	}

	.basicInforValueChild {
		width: 30%;
		height: calc(100% - 10px);
		margin-top: 10px;
	}

	.basicInforValueChild div {
		position: relative;
		width: 100%;
		height: 100%;
	}

	.basicInforValueChild div img {
		max-height: 100%;
		max-width: 100%;
	}

	.basicInforValueChild div img,
	.basicInforValueChild div span {
		position: absolute;
	}
</style>
